module.exports = __webpack_public_path__ + "static/img/Western-Star-Logo.77cf3af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Western-Star-Logo.png
// module id = snqM
// module chunks = 1